'use strict';
function updateActiveRefinementsCounter()
{
    const refinementCounter = document.querySelector('.js-getCurrentFilter');
    const currentRefinementWrapper = document.getElementById('current-refinements');
    if (currentRefinementWrapper) {
        let activeRefinements = currentRefinementWrapper.querySelectorAll('.ais-CurrentRefinements-category').length;
        refinementCounter.innerText = activeRefinements;
        if(activeRefinements > 0) {
            refinementCounter.classList.remove('hidden');
        } else {
            refinementCounter.classList.add('hidden');
        }
        document.addEventListener('click',()=> {
            setTimeout(() => {
                activeRefinements = currentRefinementWrapper.querySelectorAll('.ais-CurrentRefinements-category').length;
                if(activeRefinements > 0) {
                    refinementCounter.classList.remove('hidden');
                } else {
                    refinementCounter.classList.add('hidden');
                }
                refinementCounter.innerText = activeRefinements;
            },100);

        });
    }
}
window.updateActiveRefinementsCounter = () => updateActiveRefinementsCounter();

window.addEventListener('load', () => {
    let multidropdowns = document.querySelectorAll('.multidropdown');

    multidropdowns.forEach(multidropdown => {
        multidropdown.addEventListener('click', () => {
            closeAllMultidropdowns(multidropdown); // Übergabe des geklickten multidropdowns
            multidropdown.classList.toggle('active');
        });
    });

    const toggleFilters = document.querySelectorAll('.js-toggleFilter');
    const filterWrapper = document.getElementById('itemlist__filterWrapper');

    toggleFilters.forEach(toggleFilter => {
        if (toggleFilter) {
            toggleFilter.addEventListener('click', () => {
                filterWrapper.classList.toggle('active');
                toggleFilterFunction(toggleFilter);
            });
            toggleFilter.addEventListener("keydown", function(event) {
                if (event.key === "Enter") {
                    filterWrapper.classList.toggle('active');
                    toggleFilterFunction(toggleFilter);
                }
            });
        }
    });

    function toggleFilterFunction(filter) {
        if (window.innerWidth>481){
            filter.querySelector('.filterShow').classList.toggle('hidden');
            filter.querySelector('.filterHide').classList.toggle('hidden');
        } else {
            document.querySelector('body').classList.toggle('mobileMenuOpened');
        }
    }

    updateActiveRefinementsCounter();

    function closeAllMultidropdowns(clickedMultidropdown) {
        multidropdowns.forEach(otherMultidropdown => {
            if (otherMultidropdown !== clickedMultidropdown) {
                otherMultidropdown.classList.remove('active');
            }
        });
    }


    document.addEventListener('click', (event) => {
        if (!event.target.closest('.multidropdown')) {
            closeAllMultidropdowns();
        }
    });

    // Add click event listener to elements with class "js-toggleSortBy"
    var toggleElements = document.querySelectorAll('.js-toggleSortBy');
    toggleElements.forEach(function (element) {
        element.addEventListener('click', function (event) {
            element.classList.toggle('active');
            toggleSortBy();
        });
        element.addEventListener("keydown", function(event) {
            if (event.key === "Enter") {
                element.classList.toggle('active');
                toggleSortBy();
            }
        });
    });

// Add click event listener to the document to handle clicks outside the "sort_by" element
    document.addEventListener('click', function (event) {
        var sortByElement = document.querySelector('.sort_by');
        var sortByClicker = document.querySelector('.js-toggleSortBy');
        var targetElement = event.target;

        // Check if the clicked element is not inside the "sort_by" element
        if (sortByElement && sortByClicker && !sortByElement.contains(targetElement) && !sortByClicker.contains(targetElement)) {
            // Remove the "active" class from the "js-toggleSortBy" elements

            toggleElements.forEach(function (element) {
                element.classList.remove('active');
            });

            // Remove the "active" class from the "sort_by" element
            sortByElement.classList.remove('active');

        }
    });

    function toggleSortBy() {
        var sortByElement = document.querySelector('.sort_by');
        if (sortByElement) {
            // Toggle the "hidden" class on the "sort_by" element
            sortByElement.classList.toggle('active');
        }
    }
});
